import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../services/api';

// Injeta o SDK da Dracofy (token vem do admin) e dispara pageview a cada navegação (SPA).
export default function DracofyTracker() {
  const loc = useLocation();
  const loaded = useRef(false);

  // injeta o SDK uma vez
  useEffect(() => {
    if (loaded.current || window.__dracofyLoaded) return;
    let vivo = true;
    api.get('/tracking/public')
      .then(({ data }) => {
        if (!vivo || !data?.ativo || !data?.token) return;
        if (window.__dracofyLoaded || document.querySelector('script[data-dracofy]')) return;
        window.__dracofyLoaded = true;
        loaded.current = true;
        const s = document.createElement('script');
        s.src = 'https://cdn.dracofy.com.br/v1/index.js';
        s.setAttribute('data-token', data.token);
        s.setAttribute('data-dracofy', '1');
        s.async = true;
        document.body.appendChild(s);
      })
      .catch(() => { /* rastreamento off / offline */ });
    return () => { vivo = false; };
  }, []);

  // pageview em cada troca de rota (obrigatório em SPA) + persiste o click_id da URL
  useEffect(() => {
    try {
      const u = new URLSearchParams(loc.search);
      const cid = u.get('click_id') || u.get('fbclid');
      if (cid) localStorage.setItem('istudo:click_id', cid); // sobrevive à navegação interna
    } catch { /* ignore */ }
    try { window.DTrack?.pageview?.(loc.pathname + loc.search); } catch { /* SDK ainda não pronto */ }
  }, [loc.pathname, loc.search]);

  return null;
}
